<div *ngIf=!production
    style="background-color: yellow; text-align: center; width: 100% !important; height: 10px; font-size: 9px; color:black">
    <a class="marquee">Ambiente de pruebas</a>
</div>